<template>
    <div
    class="the-privacy-policy absolute faa-fade faa-opti"
    :class="{
        'inset-0': currentPDF,
        'bottom-0': !currentPDF,
        'right-0': !currentPDF,
        'faa-fade-in': ($route.name != 'Scenario'),
        'invisible': ($route.name == 'Scenario'),
    }">
        <div
        class="the-privacy-policy-content p-2 pb-1"
        :class="{
            'absolute': currentPDF,
            'bottom-0': currentPDF,
            'right-0': currentPDF,
        }"
        >
            <span 
            class="cursor-pointer" 
            @click="currentPDF = legalsPDF">
                CGU
            </span>
            <span> - </span>
            <span 
            class="cursor-pointer" 
            @click="currentPDF = privacyPolicyPDF">
                Politique de confidentialité
            </span>
        </div>

        <!-- PDF Modal -->
        <div class="modal-container absolute inset-0 flex flex-col items-center justify-center"
        v-if="currentPDF"
        @click="currentPDF = null">
            <div
            @click.stop
            class="absolute the-privacy-policy-modal bg-white rounded-md shadow-dark z-10 flex flex-col mb-28 mt-4">

                <!-- Modal Header -->
                <div class="the-privacy-policy-modal-header relative z-1">
                    <!-- PDF Header -->
                    <PDFViewHeader
                    :title="currentPDF.title"
                    :pdf="currentPDF"
                    @previous="previousPDFPage()"
                    @next="nextPDFPage()"
                    @close="currentPDF = null"/>
                </div>

                <!-- Modal content -->
                <div class="the-privacy-policy-modal-content">
                    <!-- PDF -->
                    <PDFView
                    :pdf="currentPDF" 
                    ref="pdf" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PDFViewHeader from '@/components/scenario/modal/PDFViewHeader'
    import PDFView from '@/components/scenario/modal/PDFView'

    export default {
        name: 'ThePrivacyPolicy',
        components: {
            PDFViewHeader,
            PDFView,
        },
        data() {
            return {
                currentPDF: null,
                legalsPDF: {
                    title: 'CGU',
                    url: '/CGU.pdf',
                    type: {
                        slug: 'file_pdf',
                    },
                },
                privacyPolicyPDF: {
                    title: 'POLITIQUE DE CONFIDENTIALITÉ',
                    url: '/POLITIQUE_DE_CONFIDENTIALITE.pdf',
                    type: {
                        slug: 'file_pdf',
                    },
                },
            }
        },
        methods: {
            previousPDFPage() {
                if (this.$refs.pdf)
                    this.$refs.pdf.previousPage()
            },
            nextPDFPage() {
                if (this.$refs.pdf)
                    this.$refs.pdf.nextPage()
            },
        }
    }
</script>

<style lang="scss" scoped>

.the-privacy-policy {
    &-content {
        @apply rounded-tl;
        opacity: 0.6;
        background-color: transparent;
        
        transition: opacity .3s;
        transition: background-color .3s;

        &:hover {
            opacity: 1;
            background-color: white;
        }

        span:hover {
            @apply border-b;
        }
    }

    &-modal { // todo: improve responsive
        width: 980px;
        max-width: 90%;
        max-height: 90%;

        &-header {
            box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);// todo
        }

        &-content {
            overflow: auto;
            height: 100%;
        }
    }
}

</style>
